import { gspx } from '@rsos/capstone';

export const trackClickDeclineReason = (
  reason,
  selectedAlertID,
  irpVersion,
) => {
  gspx.trackCustomEvent('Alert', {
    irpVersion,
    name: `Click ${reason} from decline alert`,
    Category: 'Alert',
    'Launched date': new Date(),
    AlertID: selectedAlertID,
  });
};

export const trackSendDeclineReason = (reason, selectedAlertID, irpVersion) => {
  gspx.trackCustomEvent('Alert', {
    irpVersion,
    name: `Click send ${reason} from decline alert`,
    Category: 'Alert',
    'Launched date': new Date(),
    AlertID: selectedAlertID,
  });
};
